export const categories = [
  { 
    _id: 'default', 
    name: 'Стандартная',
    color: 'white',
    title: 'Обычный приз',
  },
];